import {PaymentHistoryTable} from "@app/components/table/billingTable/PaymentHistoryTable";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainContent } from "@app/components/MainContainer/MainContent";
import {MainDescription} from "@app/components/MainContainer/MainDescription"
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { Button } from "@shortsworks/ui";
import { useGetPaymentHistories } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";

// useTable 형태로 변경
export const PaymentHistory = () => {
  const {
    data: paymentHistoriesData,
    isSuccess: isSuccessGetPaymentHistories,
    isLoading: isLoadingGetPaymentHistories,
  } = useGetPaymentHistories();

  if (!isSuccessGetPaymentHistories) {
      return (
          <div className="flex w-dvw h-dvh items-center justify-center">
              <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />;
        </div>
      );
  }

  // @ts-ignore
  const isExistPaymentHistory = paymentHistoriesData.data.length !== 0;

  return (
    <MainContentContainer>
      <MainHeader>
            <MainTitle>결제 목록</MainTitle>
            <MainDescription>현재까지 발생한 카드 결제 내역입니다.</MainDescription>
      </MainHeader>
      <MainContent>
          {
              !isExistPaymentHistory &&
              <div>결제 내역이 없습니다.</div>
          }
          {
            //   결제 금액, 결제 날짜, 카드사, 영수증
            isExistPaymentHistory &&
              <PaymentHistoryTable data={paymentHistoriesData.data ?? []}/>
          }
      </MainContent>
    </MainContentContainer>
  );
};
